/***
 * Created on 2023/7/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

const WEEKDAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];


const formatDate = (t, rec_date, ymd=false, separator='-') => {
    const new_rec = new Date(rec_date);
    const year = new_rec.getFullYear();
    const month = (new_rec.getMonth() + 1 ).toString().padStart(2, '0');
    const date = new_rec.getDate().toString().padStart(2, '0');
    const weekday = WEEKDAY[new_rec.getDay()];
    const trans_weekday = `@${weekday}@`
    if (ymd) {
        return `${year}${separator}${month}${separator}${date}`;
    }
    return `${year}${separator}${month}${separator}${date} ${t(trans_weekday)}`;
}

const formatTime = (rec_date) => {
    const new_rec = new Date(rec_date);
    const hour = new_rec.getHours().toString().padStart(2, '0');
    const minute = new_rec.getMinutes().toString().padStart(2, '0');
    const second = new_rec.getDate().toString().padStart(2, '0');
    return `${hour}:${minute}:${second}`;
}

const addDays = (rec_date, days) => {
    const new_rec = new Date(rec_date);
    return new Date( new_rec.getTime() + 60 * 60 * 24 * days * 1000);
}

export {WEEKDAY, formatDate, formatTime, addDays};